import { GridItemData } from 'vue-grid-layout'

export enum DashboardSection {
    CLINICAL = 'CLINICAL',
    REQUEST = 'REQUEST',
    REGISTRY = 'REGISTRY',
    GROSSING = 'GROSSING',
    WASTE = 'WASTE',
    INCIDENTS = 'INCIDENTS',
    OTHERS = 'OTHERS',
    DIAGNOSIS = 'DIAGNOSIS',
    LABORATORY = 'LABORATORY'
}

export enum DashboardWidgetOption {
    REQUESTS_WITH_REPORT_NOT_READ = 'requestsWithReportNotRead',
    REQUESTS_WITH_AP_REPORT_NOT_SEEN = 'requestsWithApReportNotSeen',
    REQUESTS_WITH_ISSUE = 'requestsWithIssue',
    LOCKED_REQUESTS = 'requestsInLockState',
    REGISTRY_REQUESTED = 'registryRequested',
    REGISTRY_REQUESTS_LOCKED = 'registryRequestsLocked',
    REGISTRY_TODAY = 'registryToday',
    FOR_GROSSING = 'forGrossing',
    FOR_REGROSSING = 'forRegrossing',
    GROSSING_TODAY = 'grossingToday',
    PENDING_DISPOSAL = 'toBeDiscarded',
    WASTE_TODAY = 'wasteToday',
    OPENED_INCIDENTS = 'stillOpenAndOpenedByMe',
    PORTION_MAKE = 'operation.entity.portion.make',
    PORTION_CUT = 'operation.entity.portion.cut',
    SUBPORTION_TO_SCANNER = 'operation.entity.subportion.to-scanner'
}

export interface DashboardLayout extends GridItemData {
    section: DashboardSection
    type: string
    subType?: string
    scope?: string
    prelabel?: string
    label: string
    color?: string
    icon?: string
    hidden: boolean
    disabled: boolean
    widgetLink?: string
    widgetOption?: DashboardWidgetOption
    uicomponent?: string
}
